import {
  SUPPORTED_3D_FORMATS,
  SUPPORTED_3D_FORMATS_LABEL,
  SUPPORTED_IMAGE_FORMATS,
  SUPPORTED_PROJECTOR_MESH_FORMATS_LABEL,
  SUPPORTED_VIDEO_FORMATS,
} from '@/constants/object';

export {
  SUPPORTED_3D_FORMATS,
  SUPPORTED_3D_FORMATS_LABEL,
  SUPPORTED_IMAGE_FORMATS,
  SUPPORTED_PROJECTOR_MESH_FORMATS_LABEL,
  SUPPORTED_VIDEO_FORMATS,
};

export function getAssetTypeFromFile(file) {
  const extension = file.name.split('.').pop().toLowerCase();

  if (SUPPORTED_IMAGE_FORMATS.includes(extension)) {
    return 'image';
  }

  if (SUPPORTED_VIDEO_FORMATS.includes(extension)) {
    return 'video';
  }

  if (SUPPORTED_3D_FORMATS.includes(extension)) {
    return 'scene';
  }

  return 'file';
}
